<div class="m-auto container mb-3 mt-3">


<h1>MenuLoad-ის წესები და პირობები</h1>
<p>მოგესალმებით MenuLoad-ზე! რეგისტრაციისა და ჩვენი სერვისის გამოყენების წინ, გთხოვთ, ყურადღებით გაეცნოთ ჩვენს წესებსა და პირობებს.</p>

<h2>1. საერთო დებულებები</h2>
<p>1.1. MenuLoad წარმოადგენს ონლაინ პლატფორმას, რომელიც უზრუნველყოფს ციფრულ მენიუს, შეკვეთების მართვის და გადახდის შესაძლებლობას ბიზნესებისთვის.</p>
<p>1.2. რეგისტრაციით თქვენ ადასტურებთ, რომ გაეცანით და ეთანხმებით მოცემულ წესებსა და პირობებს.</p>
<p>1.3. პლატფორმის გამოყენება შესაძლებელია მხოლოდ სამართლებრივი მიზნებისთვის და საქართველოს მოქმედი კანონმდებლობის დაცვით.</p>

<h2>2. რეგისტრაცია და მომხმარებლის პასუხისმგებლობა</h2>
<p>2.1. რეგისტრაციისას მომხმარებელი ვალდებულია მიაწოდოს სწორი და სრული ინფორმაცია.</p>
<p>2.2. მომხმარებელი პასუხისმგებელია საკუთარი ანგარიშის უსაფრთხოებაზე და არ უნდა გადასცეს თავისი ავტორიზაციის მონაცემები მესამე პირებს.</p>
<p>2.3. თუ ეჭვობთ, რომ თქვენი ანგარიში დაზარალდა ან მის მონაცემებზე მოხდა არაუფლებამოსილი წვდომა, დაუყოვნებლივ უნდა შეგვატყობინოთ.</p>

<h2>3. სერვისების გამოყენება</h2>
<p>3.1. მომხმარებელი ვალდებულია არ გამოიყენოს MenuLoad არალეგალური, ზიანის მომტანი ან თაღლითური ქმედებებისთვის.</p>
<p>3.2. პლატფორმის არასწორი გამოყენების შემთხვევაში, MenuLoad უფლებას იტოვებს, შეწყვიტოს მომხმარებლის წვდომა პლატფორმაზე.</p>
<p>3.3. MenuLoad არ არის პასუხისმგებელი მესამე მხარის მიერ განხორციელებულ თაღლითურ ქმედებებზე, თუმცა უზრუნველყოფს მაქსიმალურ დაცვას მომხმარებლის მონაცემებისთვის.</p>

<h2>4. გადასახადები და გამოწერები</h2>
<p>4.1. MenuLoad-ს შეუძლია შესთავაზოს ფასიანი გეგმები სხვადასხვა შესაძლებლობებით.</p>
<p>4.2. მომხმარებელი ვალდებულია დროულად გადაიხადოს გამოწერის ღირებულება, წინააღმდეგ შემთხვევაში, სერვისი შეიძლება შეჩერდეს.</p>
<p>4.3. თანხის დაბრუნება ხორციელდება მხოლოდ იმ შემთხვევებში, თუ ეს არის გათვალისწინებული ჩვენს პოლიტიკაში.</p>

<h2>5. კონფიდენციალურობა და მონაცემთა დაცვა</h2>
<p>5.1. მომხმარებლის მონაცემები დაცულია და არ გადაეცემა მესამე პირებს მომხმარებლის თანხმობის გარეშე.</p>
<p>5.2. პლატფორმაზე განთავსებული ინფორმაცია შეიძლება დამუშავდეს მომხმარებლის მომსახურების გაუმჯობესების მიზნით.</p>

<h2>6. წესებისა და პირობების ცვლილება</h2>
<p>6.1. MenuLoad უფლებას იტოვებს, ნებისმიერი დროს განაახლოს ან შეცვალოს მოცემული წესები.</p>
<p>6.2. ცვლილებები ძალაში შევა პლატფორმაზე გამოქვეყნებისთანავე, და მომხმარებელი ვალდებულია პერიოდულად გადაამოწმოს განახლებები.</p>

<h2>7. დავების გადაწყვეტა</h2>
<p>7.1. ყველა დავა და კონფლიქტი გადაჭრილი იქნება საქართველოს კანონმდებლობის შესაბამისად.</p>
<p>7.2. დავის შემთხვევაში, მომხმარებელი ვალდებულია პირველ რიგში დაუკავშირდეს MenuLoad-ს საკითხის მოსაგვარებლად.</p>

<h2>8. კონტაქტი</h2>
<p>თუ გაქვთ დამატებითი კითხვები, შეგიძლიათ დაგვიკავშირდეთ შემდეგ მისამართზე: <a href="mailto:support&#64;menuload.com">support&#64;menuload.com</a>
</p>

<p>რეგისტრაციით თქვენ ეთანხმებით მოცემულ წესებსა და პირობებს.</p>

</div>